module.exports = __webpack_public_path__ + "static/screenshot2-9e6a96ec94a5181f9f2ad1f35fd1fd16.png";